import React, { useState, useMemo, useEffect } from "react";
import CompactDataTable from "../../components/Common/Datatable/BasicDatatble";
import { Input } from "reactstrap";

const GuardLocationTable = ({ locations, onEntitySelect }) => {
  const [searchText, setSearchText] = useState("");


  
  // Define table columns
  const columns = [
    {
      cell: (row) => {
        const timeDifference = Date.now() - new Date(row.updatedAt);
        let statusColor = "red";
        if (timeDifference <= 3600 * 1000) statusColor = "green";
        else if (timeDifference <= 1.5 * 24 * 3600 * 1000) statusColor = "orange";

        return (
          <span
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              backgroundColor: statusColor,
              display: "inline-block",
            }}
          />
        );
      },
      width: "50px",
    },
    {
      name: "Name",
      selector: (row) =>
        row?.vehicleNumber
          ? `${row.vehicleNumber} (${row.firstName} ${row.lastName})`
          : `${row.firstName} ${row.lastName} (${row?.role})`,
      sortable: true,
    },
  ];

  // Transform locations
  const data = useMemo(() => {
    return locations?.map((guardLocation) => ({
      firstName: guardLocation.firstName,
      lastName: guardLocation.lastName,
      role: guardLocation.role,
      vehicleNumber: guardLocation.vehicleNumber,
      updatedAt: guardLocation.currentLocation?.updatedAt,
      currentLocation: guardLocation.currentLocation,
      original: guardLocation,
    })) || [];
  }, [locations]);



  const getStatusColor = (updatedAt) => {
    const timeDifference = Date.now() - new Date(updatedAt);
    if (timeDifference <= 3600 * 1000) return "green"; // within 1 hour
    else if (timeDifference <= 1.5 * 24 * 3600 * 1000) return "orange"; // within 1.5 days
    return "red"; // older
  };
  
  const countStatusColors = (rows) => {
    const counts = { green: 0, orange: 0, red: 0 };
  
    rows.forEach((row) => {
      const color = getStatusColor(row.updatedAt);
      counts[color]++;
    });
  
    console.log("Color counts:", counts);
    return counts;
  };

  useEffect(() => {
    if (data?.length) {
      countStatusColors(data);
    }
  }, [data]);
  

  // Filter data based on search input
  const filteredData = useMemo(() => {
    const lowerSearch = searchText.toLowerCase();
    return data.filter((item) => {
      const name = `${item.firstName} ${item.lastName}`.toLowerCase();
      const vehicle = item.vehicleNumber?.toLowerCase() || "";
      const role = item.role?.toLowerCase() || "";
      return (
        name.includes(lowerSearch) ||
        vehicle.includes(lowerSearch) ||
        role.includes(lowerSearch)
      );
    });
  }, [data, searchText]);

  const handleRowClick = (row) => {
    if (onEntitySelect) {
      onEntitySelect({
        firstName: row.firstName,
        lastName: row.lastName,
        role: row.role,
        vehicleNumber: row.vehicleNumber,
        currentLocation: row.currentLocation,
      });
    }
  };

  return (
    <div>
      <div style={{ padding: "10px 0px" }}>
        <Input
          type="text"
          placeholder="Search by name, vehicle number"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>
      <CompactDataTable
        columns={columns}
        data={filteredData}
        onRowClicked={handleRowClick}
        highlightOnHover
        pointerOnHover
      />
    </div>
  );
};

export default GuardLocationTable;
